import { showErrorToast } from "../../../configurator/renderer/tools/helper";
import { useUiTranslator } from "../../../hooks/useUiTranslator";
import {
  getGetApiEasyAdministrationAreaQueryKey,
  useGetApiQuoteApiGetQuoteId,
} from "../../../openapi/backendApi";
import { useEasySession } from "../../../providers/easySessionProvider";

import { JSX, useEffect, useEffectEvent, useRef, useState } from "react";

//import { useLanguage } from "@4pace-cpq/core";
import { Box, CircularProgress, Container } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useSearch } from "@tanstack/react-router";

interface ISearchObj {
  language: string;
  productCategory?: string;
}

export const CustomOpportunityRouteComponent = (): JSX.Element => {
  const t = useUiTranslator();
  const [isLoadingWegWebsite, setIsLoadingWegWebsite] = useState<boolean>(true);

  const { checkLogin } = useEasySession();
  const queryClient = useQueryClient();
  const isHandlingEasySession = useRef(false);
  const navigate = useNavigate();
  const searchparams = useSearch({ strict: false });
  const {
    language,
    origin,
    purchaseCountry,
    catalog,
    customer,
    customerName,
    productCategory,
    intermediateToken,
    sessionFromEasy,
  } = useSearch({ strict: false });
  const {
    data: quoteId,
    isSuccess,
    refetch: refetchQuoteId,
  } = useGetApiQuoteApiGetQuoteId({
    query: { enabled: !(productCategory && origin) },
  });
  console.log("-----------------------------");
  console.log("searchparams", searchparams);

  const handleNavigateToCart = ({
    productCategory,
    quoteIdOverride,
  }: {
    productCategory?: string;
    quoteIdOverride?: string;
  }): void => {
    const searchObj: ISearchObj = {
      language,
    };
    if (productCategory) {
      searchObj.productCategory = productCategory;
    }
    const resolvedQuoteId = quoteIdOverride ?? quoteId?.data;
    if (resolvedQuoteId) {
      navigate({
        to: `/cart/${resolvedQuoteId}`,
        search: () => searchObj,
      });
    } else {
      console.error("Error - No valid quote exists. quoteId:", resolvedQuoteId);
    }
  };

  const handlePostSessionFromWegWebsite = async (): Promise<void> => {
    setIsLoadingWegWebsite(true);
    await fetch("/api/Easy/SessionFromWegWebsite", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        language,
        origin,
        purchaseCountry,
        catalog,
        customer,
        customerName,
        productCategory,
        intermediateToken,
      }),
    }).then(async (response) => {
      setIsLoadingWegWebsite(false);
      checkLogin();
      const { data: refetchedQuoteId } = await refetchQuoteId();
      handleNavigateToCart({
        productCategory,
        quoteIdOverride: refetchedQuoteId?.data,
      });

      if (!response.ok) {
        const data = await response.json();
        showErrorToast(
          t(`CustomApp:${data.key}`, "An error occurred", {
            params: data.params,
          }),
        );
      }
    });
  };

  const handleUseSessionFromEasy = async (): Promise<void> => {
    if (isHandlingEasySession.current) return;
    isHandlingEasySession.current = true;
    setIsLoadingWegWebsite(true);
    await fetch(`/api/QuoteApi/ConvertSessionFromEasy/${sessionFromEasy}`, {
      method: "GET",
    });
    setIsLoadingWegWebsite(false);
    await queryClient.invalidateQueries({
      queryKey: getGetApiEasyAdministrationAreaQueryKey(),
    });
    await checkLogin();
    const { data: refetchedQuoteId } = await refetchQuoteId();
    handleNavigateToCart({ quoteIdOverride: refetchedQuoteId?.data });
  };

  const handleEffect = useEffectEvent((): void => {
    if (sessionFromEasy) {
      handleUseSessionFromEasy();
    } else if (origin && productCategory) {
      handlePostSessionFromWegWebsite();
    } else if (quoteId && !origin) {
      handleNavigateToCart({});
    }
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    handleEffect();
  }, [isSuccess]);

  return (
    <Container>
      <Box my={4}>
        {isLoadingWegWebsite || !quoteId ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            mb={4}
          >
            <CircularProgress />
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </Container>
  );
};
